import { Decoded } from '@e3dc-react/shell/Types'
import { LoginSearchParameter } from 'src/Hooks/login/types'
import {
  CHANGE_EMAIL_QUERY_PARAM,
  COMPANY_QUERY_TOKEN_PARAM,
  INSTALLATION_INVITATION_TOKEN_QUERY_PARAM,
  PROTECTED_FILE_QUERY_PARAM,
  REAUTH_QUERY_TOKEN_PARAM,
  TOKEN_QUERY_PARAM,
} from 'src/Libs/navigation/consts'
import JWT from 'jsonwebtoken'

/**
 * Get the search parameters from the URL like token, reAuthToken, staticToken, samlKey, invitationToken, companyToken, changeEmailToken
 */
export const getLoginSearchParameters = (): Record<keyof LoginSearchParameter, string> => {
  const includesInvitation = globalThis.location.search.includes(INSTALLATION_INVITATION_TOKEN_QUERY_PARAM)
  const includesCompanyInvitation = globalThis.location.search.includes(COMPANY_QUERY_TOKEN_PARAM)
  const includesChangeEmailToken = globalThis.location.search.includes(CHANGE_EMAIL_QUERY_PARAM)
  const includesProtectedFileToken = globalThis.location.search.includes(PROTECTED_FILE_QUERY_PARAM)
  const includesLoginToken = globalThis.location.search.includes(TOKEN_QUERY_PARAM) && globalThis.location.search.includes(REAUTH_QUERY_TOKEN_PARAM)

  if (includesLoginToken && (includesInvitation || includesCompanyInvitation || includesChangeEmailToken || includesProtectedFileToken)) {
    return globalThis.location.search
      .substring(1)
      .split('?')
      .join('&')
      .split('&')
      .reduce((prev, curr) => {
        if (curr) {
          const splitted = curr.split('=')
          return { ...prev, [splitted[0]]: splitted[1] }
        }
        return prev
      }, {}) as Record<keyof LoginSearchParameter, string>
  }
  const test = globalThis.location.search
    .substring(1)
    .split('&')
    .reduce((prev, curr) => {
      if (curr) {
        const splitted = curr.split('=')
        return { ...prev, [splitted[0]]: splitted[1] }
      }
      return prev
    }, {}) as Record<keyof LoginSearchParameter, string>
  return test
}

export const decodeToken = (token?: string): Decoded | undefined => {
  if (token) {
    return JWT.decode(token) as Decoded
  }
  return undefined
}
